<template>
    <div style="backgroundColor:#F4FEFB;padding:20px">
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-row>
            <v-col cols="12" xl="6" class="text-h4">テンプレートから入力項目をインポート</v-col>
        </v-row>
        <!-- テーブル -->
        <template>
            <v-pagination
                v-model="indexInfo.page"
                :length="indexInfo.pageCount"
            ></v-pagination>
            <v-data-table
                :items="templateItems"
                :page.sync="indexInfo.page"
                :items-per-page="indexInfo.itemsPerPage"
                @page-count="indexInfo.pageCount = $event"
                disable-sort
                hide-default-headers
                hide-default-footer
                class="mx-3"
            >
                <template v-slot:body="props">
                    <tr v-for="(item, index) in props.items" :key="index">
                        <td class="item-td" align="center" width="5%;">
                        </td>
                        <td class="item-td" align="left" width="75%;">
                            <template>
                                {{ item.template_name }}
                            </template>
                        </td>

                        <td align="center">
                            <v-btn color="red" class="white--text" width="15%;" @click="dialog(item)">インポート</v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </template>

    <template>
        <v-dialog v-model="handleDialog" width="700"class="common-dialog">
            <v-card color="#F4FEFB">
                <v-card-title class="justify-left text-h4">
                    {{ templatName }} 
                    <p style="width:100%">テンプレートに複数のPDFが存在します。インポートするPDFを選択してください。</p>
                </v-card-title>
                <v-radio-group v-model="pdf" mandatory>
                <template>
                    <div style="min-height:68px;">
                    <v-overlay :absolute="true" :value="sending" z-index="10000">
                        <v-progress-circular
                            indeterminate
                            size="64"
                        ></v-progress-circular>
                        <span class="loading">処理中です...</span>
                    </v-overlay>
                    <tr v-for="(pdf, index) in pdfs" :key="index">
                        <td class="item-td" align="center" width="5%;">
                        </td>
                        <td class="item-td" align="center" width="5%;">
                            <v-radio
                              :value="pdf"
                            ></v-radio>
                        </td>
                        <td class="item-td" align="left" width="75%;">
                            {{ pdf.filename }}
                        </td>
                    </tr>
                    </div>
                </template>
                </v-radio-group>
                <v-divider></v-divider>
                <v-card-actions class="justify-center grey lighten-4 pb-6">
                    <v-btn min-width="150px" class="white--text" color="red" large @click="confirmInputImport">
                        はい
                    </v-btn>
                    <v-btn min-width="150px" class="white--text" color="blue-grey" large @click="handleDialog = false">
                        キャンセル
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="confirmDialog" width="700"class="common-dialog">
            <v-card color="#F4FEFB">
                <v-card-title class="justify-left text-h4">
                    <p style="width:100%">すでに配置されている入力項目は削除されます。よろしいでしょうか？</p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-actions class="justify-center grey lighten-4 pb-6">
                    <v-btn min-width="150px" class="white--text" color="red" large @click="inputImport(uid,currentUid,currentPdfId,pdf,maxPages,pdfWidth)">
                        はい
                    </v-btn>
                    <v-btn min-width="150px" class="white--text" color="blue-grey" large @click="confirm(false)">
                        キャンセル
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>
    </div>
</template>

<script>
    export default {
        props: ['currentPdfId', 'currentUid', 'templateItems', 'maxPages', 'pdfWidth', 'inputs'],
        data() {
            return {
                message: {
                    success: false,
                    text: '',
                },
                sending: false,
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                handleDialog: false,
                confirmDialog: false,
                templatName: '',
                pdfs:[],
                pdf:{},
                uid:0,
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        methods: {
            dialog (item) {
                this.templatName = item.template_name;
                this.uid = item.object_id;
                this.getPdfs(this.uid);
                if(item.contract_template_real_documents.length > 0){
                    if(item.contract_template_real_documents.length == 1){
                        this.pdf = item.contract_template_real_documents[0];
                        this.confirmInputImport()
                    }else{
                        this.handleDialog = true;
                    }
                }
            },
            inputImport: async function (uid,currentUid,currentPdfId,pdf,maxPages,pdfWidth) {
                this.handleDialog = false;
                this.confirm(false);
                this.$emit('templateInput', false);
                await this.$emit("templateInputSave",uid,currentUid,currentPdfId,pdf,maxPages,pdfWidth);
            },
            confirmInputImport: function(){
                let hasInput = false
                if (Object.keys(this.inputs).length > 0 && typeof this.inputs[this.currentPdfId] != 'undefined') {
                    Object.keys(this.inputs[this.currentPdfId]).forEach((page) => {
                        Object.keys(this.inputs[this.currentPdfId][page]).forEach((key) => {
                            if(!this.inputs[this.currentPdfId][page][key].deleted){
                                hasInput = true
                                return false
                            }
                        })
                    })
                }
                
                if(hasInput){
                    this.confirm(true)
                }else{
                    this.inputImport(this.uid,this.currentUid,this.currentPdfId,this.pdf,this.maxPages,this.pdfWidth)
                }
            },
            confirm: function(isOpen){
                this.confirmDialog = isOpen;
            },
            // PDF情報取得
            getPdfs: async function (uid) {
                let result = false;
                var self = this;
                self.sending = true;
                self.pdfs = [];
                await window.axios
                    .post('get-pdfs', {'uid': uid})
                    .then(function (response) {
                        if (response.data.success) {
                            self.pdfs = response.data.pdfs;
                        } 
                        else {
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "PDF情報取得処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        self.message.text = "PDF情報取得処理に失敗しました";
                        self.message.success = false;
                    })
                    .finally(function () {
                        self.sending = false;
                    });
            },
        },
    };
</script>
<style scoped>
    /* table */
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
    }
</style>